export enum ROLE {
  ADMIN = 1,
  OPERATOR = 20,
}

export const enum SHARE {
  NOSHARE = 0,
  ORGANIZATION = 2,
  USERS = 1,
}
